export default [
  {
    path: '/app/brands',
    name: 'Brands',
    component: () => import('@/views/Admin/Brands/Index.vue'),
    meta: {
      pageTitle: 'Markalarımız',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_BRANDS',
      action: 'read',
    },
  },
  {
    path: '/app/brands/add',
    name: 'BrandAdd',
    component: () => import('@/views/Admin/Brands/Add.vue'),
    meta: {
      pageTitle: 'Markalarımız',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/brands',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_BRANDS',
      action: 'read',
    },
  },
  {
    path: '/app/brands/edit/:id',
    name: 'BrandEdit',
    component: () => import('@/views/Admin/Brands/Edit.vue'),
    meta: {
      pageTitle: 'Markalarımız',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/brands',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_BRANDS',
      action: 'read',
    },
  },
]
